var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBookmarkUnsaved2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16016 16.2522V5.83124C4.16016 4.44995 5.27991 3.3302 6.6612 3.3302H13.3306C14.7119 3.3302 15.8317 4.44995 15.8317 5.83124V16.2522C15.8318 16.4085 15.7445 16.5517 15.6056 16.6232C15.4666 16.6947 15.2993 16.6825 15.1722 16.5916L10.2385 13.0668C10.0935 12.9629 9.89839 12.9629 9.75332 13.0668L4.8196 16.5907C4.69264 16.6816 4.52555 16.6939 4.38665 16.6226C4.24776 16.5513 4.16034 16.4084 4.16016 16.2522Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBookmarkUnsaved2);
export default __webpack_public_path__ + "static/media/IconBookmarkUnsaved2.9bde6c87ebc52a881e13e593c4da259c.svg";
export { ForwardRef as ReactComponent };